import { Observable } from 'rxjs/index';
import Event from '../../core/Event';
import { filter, map, mergeMap } from 'rxjs/internal/operators';
import { default as CognitoUserAuthenticator } from './CognitoUserAuthenticator';
import RequestFailed from '../../core/events/RequestFailed';
import UserLogoutCompleted from '../events/UserLogoutCompleted';

export default (event$: Observable<Event>): Observable<Event> =>
    event$.pipe(
        filter((anyEvent: Event) => {
            if (anyEvent.type === RequestFailed.type) {
                const event: RequestFailed = anyEvent as RequestFailed;
                return event.status === 401;
            }
            return false;
        }),
        mergeMap(() => {
            return CognitoUserAuthenticator.logout().pipe(
                map(() => {
                    return new UserLogoutCompleted();
                })
            );
        })
    );



// WEBPACK FOOTER //
// ./src/application/user/epic/sessionExpired.ts